import * as React from "react";
import { SVGProps } from "react";
export const BriefcaseIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.5 17C3.0875 17 2.73438 16.8531 2.44063 16.5594C2.14688 16.2656 2 15.9125 2 15.5V6.5C2 6.0875 2.14688 5.73438 2.44063 5.44063C2.73438 5.14688 3.0875 5 3.5 5H6V3.49562C6 3.08187 6.14687 2.72917 6.44063 2.4375C6.73438 2.14583 7.0875 2 7.5 2H12.5C12.9125 2 13.2656 2.14688 13.5594 2.44063C13.8531 2.73438 14 3.0875 14 3.5V5H16.5C16.9125 5 17.2656 5.14688 17.5594 5.44063C17.8531 5.73438 18 6.0875 18 6.5V15.5C18 15.9125 17.8531 16.2656 17.5594 16.5594C17.2656 16.8531 16.9125 17 16.5 17H3.5ZM7.5 5H12.5V3.5H7.5V5ZM16.5 12.25H12.5V13.25C12.5 13.4625 12.4281 13.6406 12.2844 13.7844C12.1406 13.9281 11.9625 14 11.75 14H8.25C8.0375 14 7.85938 13.9281 7.71563 13.7844C7.57188 13.6406 7.5 13.4625 7.5 13.25V12.25H3.5V15.5H16.5V12.25ZM9 12.5H11V10.5H9V12.5ZM3.5 10.75H7.5V9.75C7.5 9.5375 7.57188 9.35937 7.71563 9.21562C7.85938 9.07187 8.0375 9 8.25 9H11.75C11.9625 9 12.1406 9.07187 12.2844 9.21562C12.4281 9.35937 12.5 9.5375 12.5 9.75V10.75H16.5V6.5H3.5V10.75Z"
            fill="currentColor"
        />
    </svg>
);
BriefcaseIcon.displayName = "BriefcaseIcon";
